module.exports = __webpack_public_path__ + "static/media/icon_puzzle.89e6527c.svg";